module.exports = __webpack_public_path__ + "static/media/arrow-right-2.3abeb9dd.svg";